import { render, staticRenderFns } from "./machine-owner-details.vue?vue&type=template&id=1b6e081c&"
import script from "./machine-owner-details.vue?vue&type=script&lang=js&"
export * from "./machine-owner-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports